import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";

import { useSnackbar } from "notistack";
import {
  createStudentsAPIEndpoint,
  EndPoints,
} from "../../../../services/StudentAPIs";
function StudentDialog({
  open,
  onClose,
  onStudentAdded,
  onStudentUpdated,
  centers,
  selectedStudent,
}) {
  const { enqueueSnackbar } = useSnackbar();

  const [student, setStudent] = useState({
    fullName: "",
    phoneNumber: "",
    parentNumber: "",
    centerId: "",
  });

  const [errors, setErrors] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const isEditMode = Boolean(selectedStudent);

  const handleChange = (field, value) => {
    setStudent({ ...student, [field]: value });
  };

  const validate = () => {
    let temp = {};
    const egyptPhoneRegex = /^(01)[0-2,5]{1}[0-9]{8}$/;
    temp.fullName = student.fullName ? "" : "Full Name is required.";
    temp.phoneNumber = student.phoneNumber ? "" : "Phone Number is required.";
    if (!student.phoneNumber)
      temp.phoneNumber = "Please enter your phone number.";
    else if (!egyptPhoneRegex.test(student.phoneNumber))
      temp.phoneNumber = "Invalid Egyptian phone number.";
    else temp.phoneNumber = "";
    if (!student.parentNumber)
      temp.parentNumber = "Please enter your parent phone number.";
    else if (!egyptPhoneRegex.test(student.parentNumber))
      temp.parentNumber = "Invalid Egyptian phone number.";
    else if (student.parentNumber === student.phoneNumber)
      temp.parentNumber =
        "Parent phone number cannot be the same as phone number.";
    else temp.parentNumber = "";
    temp.centerId = student.centerId ? "" : "Center is required.";
    setErrors(temp);
    return Object.values(temp).every((x) => x === "");
  };
  useEffect(() => {
    if (selectedStudent) {
      setStudent({
        fullName: selectedStudent.fullName || "",
        phoneNumber: selectedStudent.phoneNumber || "",
        parentNumber: selectedStudent.parentNumber || "",
        centerId: selectedStudent.centerId || "",
      });
    } else {
      setStudent({
        fullName: "",
        phoneNumber: "",
        parentNumber: "",
        centerId: "",
      });
    }
    setErrors({});
  }, [selectedStudent, open]);
  const handleAddStudent = () => {
    if (!validate()) return;
    const formData = new FormData();
    formData.append("fullName", student.fullName);
    formData.append("parentNumber", student.parentNumber);
    formData.append("phoneNumber", student.phoneNumber);
    formData.append("centerId", student.centerId);
    try {
      createStudentsAPIEndpoint(EndPoints.addStudent)
        .postWithToken(formData)
        .then((res) => {
          setIsDisabled(true);
          enqueueSnackbar("student created successfully!", {
            variant: "success",
          });
          if (onStudentAdded) onStudentAdded(res.data);
          handleClose();
        })
        .catch((err) => {
          console.error("Failed to create student:", err);
          enqueueSnackbar("Failed to create student.", { variant: "error" });
        });
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    }
  };
  const handleEditStudent = async () => {
    if (!validate()) return;

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("fullName", student.fullName);
      formData.append("centerId", student.centerId);
      formData.append("phoneNumber", student.phoneNumber);
      formData.append("parentNumber", student.parentNumber);

      await createStudentsAPIEndpoint(EndPoints.editStudent(selectedStudent.id)).put(
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      enqueueSnackbar("Student updated successfully", {
        variant: "success",
      });

      onStudentUpdated?.();
      onClose();
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.response?.data?.Message ||
        "Failed to update student.";

      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setStudent({
      fullName: "",
      phoneNumber: "",
      parentNumber: "",
      centerId: "",
    });

    setErrors({});
    setLoading(false);
    setIsDisabled(false);

    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      className="add-student-dialog"
    >
      <DialogTitle>
        {isEditMode ? "Edit Student" : "Add New Student"}
      </DialogTitle>{" "}
      <DialogContent>
        <TextField
          fullWidth
          label="Full Name"
          margin="normal"
          value={student.fullName}
          onChange={(e) => handleChange("fullName", e.target.value)}
          error={!!errors.fullName}
          helperText={errors.fullName}
          className="student-dialog-textfield"
        />

        <TextField
          fullWidth
          type="text"
          label="Phone Number"
          margin="normal"
          value={student.phoneNumber}
          onChange={(e) => handleChange("phoneNumber", e.target.value)}
          error={!!errors.phoneNumber}
          helperText={errors.phoneNumber}
          className="student-dialog-textfield"
        />

        <TextField
          fullWidth
          type="text"
          label="Parent Phone Number"
          margin="normal"
          value={student.parentNumber}
          onChange={(e) => handleChange("parentNumber", e.target.value)}
          error={!!errors.parentNumber}
          helperText={errors.parentNumber}
          className="student-dialog-textfield"
        />
        <TextField
          fullWidth
          select
          label="Center"
          margin="normal"
          value={student.centerId}
          onChange={(e) => handleChange("centerId", e.target.value)}
          error={!!errors.centerId}
          helperText={errors.centerId}
          className="student-dialog-textfield"
        >
          {centers.map((center) => (
            <MenuItem key={center.id} value={center.id} className="li">
              {center.name}
            </MenuItem>
          ))}
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} className="btn-cancel">
          Cancel
        </Button>
        <Button
          onClick={isEditMode ? handleEditStudent : handleAddStudent}
          disabled={loading || isDisabled}
          variant="contained"
          color="primary"
          className="btn-save"
        >
          {loading ? "Saving..." : isEditMode ? "Update" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default StudentDialog;
